// extracted by mini-css-extract-plugin
module.exports = {"option":"lC8ZZ"};